// import React, { useEffect, useState } from 'react';
// import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
// import {
//   Button, Dialog, DialogActions, DialogContent, DialogContentText,
//   DialogTitle, useMediaQuery, CircularProgress, Snackbar, Alert, Box, Typography
// } from '@mui/material';
// import CryptoJS from 'crypto-js';
// import { getDecryptedRefreshToken } from '../../LoginUserDetails.js/LoginUserSavedDetails';
// import RiteAdminSidebar from '../../../Container/RiteAdmin/RiteAdminSidebar';
// import ApiServices from '../../ApiServices/ApiServices';

// const SIDEBAR_BG = "#122b2a";
// const SIDEBAR_ACTIVE = "#1c7c6c";

// const RiteAdminRoutes = () => {
//   const isMobile = useMediaQuery("(max-width:767px)");
//   const isTablet = useMediaQuery("(min-width:768px) and (max-width:1199px)");
//   const [sidebarWidth, setSidebarWidth] = useState(isMobile ? 0 : isTablet ? 64 : 240);

//   const [showDialog, setShowDialog] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');

//   const navigate = useNavigate();
//   const location = useLocation();
//   const RefreshToken = getDecryptedRefreshToken();
//   const timeoutDuration = 30 * 60 * 1000;

//   /* ================= SESSION TIMEOUT ================= */
//   useEffect(() => {
//     const timeout = setTimeout(() => {
//       setShowDialog(true);
//     }, timeoutDuration - 5 * 60 * 1000);

//     const resetTimeout = () => {
//       clearTimeout(timeout);
//       setShowDialog(false);
//     };

//     window.addEventListener('click', resetTimeout);
//     window.addEventListener('keypress', resetTimeout);

//     return () => {
//       clearTimeout(timeout);
//       window.removeEventListener('click', resetTimeout);
//       window.removeEventListener('keypress', resetTimeout);
//     };
//   }, [timeoutDuration]);

//   /* ================= LOGOUT ================= */
//   const handleLogout = () => {
//     setLoading(true);
//     setTimeout(() => {
//       setShowDialog(false);
//       sessionStorage.clear();
//       navigate('/provider-emr-login');
//       setLoading(false);
//     }, 1500);
//   };

//   /* ================= CONTINUE SESSION ================= */
//   const handleContinueSession = () => {
//     setLoading(true);
//     const payload = {
//       user_role: "users",
//       client_id: process.env.REACT_APP_CLINTID_ACS_TKN,
//       scope: process.env.REACT_APP_PROVIDER_SCOPES,
//       grant_type: "refresh_token",
//       refresh_token: RefreshToken,
//     };

//     ApiServices.post("/oauth2/default/token", payload, {
//       "Content-Type": "application/x-www-form-urlencoded",
//     })
//       .then((response) => {
//         const secretKey = process.env.REACT_APP_SECRET_KEY;
//         sessionStorage.setItem("LoginUserAccessToken", CryptoJS.AES.encrypt(response.data.access_token, secretKey).toString());
//         sessionStorage.setItem("LoginUserRefreshToken", CryptoJS.AES.encrypt(response.data.refresh_token, secretKey).toString());
//         setShowDialog(false);
//       })
//       .catch(() => {
//         setSnackbarMessage("Session renewal failed. Please login again.");
//         setSnackbarOpen(true);
//       })
//       .finally(() => setLoading(false));
//   };

//   /* ================= BREADCRUMB ================= */
//   const pageTitle = location.pathname.split("/").filter(Boolean).pop() || "dashboard";
//   const formattedTitle = pageTitle.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

//   return (
//     <Box sx={{ display: "flex", minHeight: "100vh", backgroundColor: "#f8fafa" }}>
//       {/* Sidebar */}
//       <RiteAdminSidebar onSidebarChange={setSidebarWidth} />

//       {/* Main Content Area */}
//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           ml: isMobile ? 0 : `${sidebarWidth}px`,
//           transition: "margin-left 0.3s ease",
//           display: "flex",
//           flexDirection: "column",
//           minHeight: "100vh",
//           width: isMobile ? "100%" : `calc(100% - ${sidebarWidth}px)`,
//         }}
//       >
//         {/* Top Header */}
//         <Box
//           sx={{
//             position: "sticky",
//             top: 0,
//             zIndex: 10,
//             backgroundColor: "#fff",
//             borderBottom: "1px solid #e8eded",
//             px: { xs: 2, sm: 3 },
//             py: 1.5,
//             display: "flex",
//             alignItems: "center",
//             pl: isMobile ? 7 : { xs: 2, sm: 3 },
//           }}
//         >
//           <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//             <Typography
//               onClick={() => navigate("/provider/dashboard")}
//               sx={{
//                 fontSize: 13,
//                 color: SIDEBAR_ACTIVE,
//                 cursor: "pointer",
//                 fontWeight: 500,
//                 "&:hover": { textDecoration: "underline" },
//               }}
//             >
//               Home
//             </Typography>
//             <Typography sx={{ fontSize: 13, color: "#999", mx: 0.5 }}>›</Typography>
//             <Typography sx={{ fontSize: 13, color: "#333", fontWeight: 600 }}>
//               {formattedTitle}
//             </Typography>
//           </Box>
//         </Box>

//         {/* Routes Content */}
//         <Box sx={{ flex: 1, p: { xs: 2, sm: 3 }, overflow: "auto" }}>
//           <Routes>

// </Routes>
//         </Box>
//       </Box>

//       {/* Session Expiry Dialog */}
//       <Dialog open={showDialog} PaperProps={{ sx: { borderRadius: "12px", minWidth: 350 } }}>
//         <DialogTitle sx={{ fontWeight: 600, color: SIDEBAR_BG }}>Session Expiring</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Your session will expire in 5 minutes. Do you want to continue?
//           </DialogContentText>
//           {loading && <CircularProgress size={24} sx={{ mt: 2, color: SIDEBAR_ACTIVE }} />}
//         </DialogContent>
//         <DialogActions sx={{ px: 3, pb: 2 }}>
//           <Button
//             onClick={handleContinueSession}
//             variant="contained"
//             disabled={loading}
//             sx={{
//               borderRadius: "8px",
//               backgroundColor: SIDEBAR_ACTIVE,
//               "&:hover": { backgroundColor: "#15635a" },
//             }}
//           >
//             Continue
//           </Button>
//           <Button
//             onClick={handleLogout}
//             variant="outlined"
//             disabled={loading}
//             sx={{
//               borderRadius: "8px",
//               color: "#ef4444",
//               borderColor: "#ef4444",
//               "&:hover": { backgroundColor: "rgba(239,68,68,0.05)", borderColor: "#dc2626" },
//             }}
//           >
//             Log Out
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Snackbar */}
//       <Snackbar open={snackbarOpen} autoHideDuration={4000} onClose={() => setSnackbarOpen(false)}>
//         <Alert severity="error" onClose={() => setSnackbarOpen(false)} sx={{ borderRadius: "8px" }}>
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default RiteAdminRoutes;

import React, { useEffect, useState } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useMediaQuery,
  CircularProgress,
  Snackbar,
  Alert,
  Box,
  Typography,
} from "@mui/material";

import CryptoJS from "crypto-js";
import { getDecryptedRefreshToken } from "../../LoginUserDetails.js/LoginUserSavedDetails";

import RiteAdminSidebar from "../../../Container/RiteAdmin/RiteAdminSidebar";
import ApiServices from "../../ApiServices/ApiServices";
import RiteDepartmentTabs from "../../../Components/RiteAdmin/RiteDepartment/RiteDepartmentTabs";
import RiteUserTabs from "../../../Components/RiteAdmin/RiteUsers/RiteUserTabs";
import RiteClientTabs from "../../../Components/RiteAdmin/RiteClients/RiteClientTabs";
import RiteCategories from "../../../Components/RiteAdmin/RiteCategories/RiteCategories";
import RestaurantCustomerRegisterForm from "../../../Components/RestaurantCustomer/RestaurantCustomerRegisterForm";

const SIDEBAR_BG = "#122b2a";
const SIDEBAR_ACTIVE = "#1c7c6c";

const RiteAdminRoutes = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(min-width:768px) and (max-width:1199px)");

  const [sidebarWidth, setSidebarWidth] = useState(
    isMobile ? 0 : isTablet ? 64 : 240,
  );

  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  const timeoutDuration = 30 * 60 * 1000; // 30 minutes

  const secretKey = process.env.REACT_APP_USER_ENC_DEC_KEY;

  /* ================= REFRESH TOKEN FUNCTION ================= */

  const refreshAccessToken = async () => {
    try {
      const refreshToken = getDecryptedRefreshToken();

      if (!refreshToken) throw new Error("No refresh token");

      const response = await ApiServices.post("/api/token/refresh/", {
        refresh: refreshToken,
      });

      const newAccessToken = response.data.access;

      sessionStorage.setItem(
        "LoginUserAccessToken",
        CryptoJS.AES.encrypt(newAccessToken, secretKey).toString(),
      );

      return newAccessToken;
    } catch (error) {
      sessionStorage.clear();
      navigate("/provider-emr-login");
      return null;
    }
  };

  /* ================= SESSION TIMEOUT WARNING ================= */

  useEffect(() => {
    const timeout = setTimeout(
      () => {
        setShowDialog(true);
      },
      timeoutDuration - 5 * 60 * 1000,
    ); // show warning 5 min before expiry

    const resetTimeout = () => {
      clearTimeout(timeout);
      setShowDialog(false);
    };

    window.addEventListener("click", resetTimeout);
    window.addEventListener("keypress", resetTimeout);

    return () => {
      clearTimeout(timeout);
      window.removeEventListener("click", resetTimeout);
      window.removeEventListener("keypress", resetTimeout);
    };
  }, [timeoutDuration]);

  /* ================= AUTO REFRESH EVERY 60 MINUTES ================= */

  useEffect(() => {
    const interval = setInterval(
      async () => {
        const confirmRefresh = window.confirm(
          "Your session will be refreshed to keep you logged in. Continue?",
        );

        if (confirmRefresh) {
          await refreshAccessToken();
        } else {
          handleLogout();
        }
      },
      60 * 60 * 1000,
    );

    return () => clearInterval(interval);
  }, []);

  /* ================= LOGOUT ================= */

  const handleLogout = () => {
    setLoading(true);

    setTimeout(() => {
      sessionStorage.clear();
      navigate("/provider-emr-login");
      setLoading(false);
    }, 1000);
  };

  /* ================= CONTINUE SESSION ================= */

  const handleContinueSession = async () => {
    setLoading(true);

    try {
      const token = await refreshAccessToken();

      if (token) {
        setShowDialog(false);
      } else {
        throw new Error("Token refresh failed");
      }
    } catch {
      setSnackbarMessage("Session renewal failed. Please login again.");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  /* ================= PAGE TITLE ================= */

  const pageTitle =
    location.pathname.split("/").filter(Boolean).pop() || "dashboard";

  const formattedTitle = pageTitle
    .replace(/-/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

  return (
    <Box
      sx={{ display: "flex", minHeight: "100vh", backgroundColor: "#f8fafa" }}
    >
      {/* Sidebar */}
      <RiteAdminSidebar onSidebarChange={setSidebarWidth} />

      {/* Main Area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          ml: isMobile ? 0 : `${sidebarWidth}px`,
          transition: "margin-left 0.3s ease",
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          width: isMobile ? "100%" : `calc(100% - ${sidebarWidth}px)`,
        }}
      >
        {/* Header */}
        <Box
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 10,
            backgroundColor: "#fff",
            borderBottom: "1px solid #e8eded",
            px: { xs: 2, sm: 3 },
            py: 1.5,
            display: "flex",
            alignItems: "center",
            pl: isMobile ? 7 : { xs: 2, sm: 3 },
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <Typography
              onClick={() => navigate("/rite-admin/dashboard")}
              sx={{
                fontSize: 13,
                color: SIDEBAR_ACTIVE,
                cursor: "pointer",
                fontWeight: 500,
                "&:hover": { textDecoration: "underline" },
              }}
            >
              Home
            </Typography>

            <Typography sx={{ fontSize: 13, color: "#999", mx: 0.5 }}>
              ›
            </Typography>

            <Typography sx={{ fontSize: 13, color: "#333", fontWeight: 600 }}>
              {formattedTitle}
            </Typography>
          </Box>
        </Box>

        {/* Page Routes */}
        <Box sx={{ flex: 1, p: { xs: 2, sm: 3 }, overflow: "auto" }}>
          <Routes>
            <Route path="/rite-departments" element={<RiteDepartmentTabs />} />
            <Route path="/rite-staff" element={<RiteUserTabs />} />
            <Route path="/rite-clients" element={<RiteClientTabs/>} />
            <Route path="/rite-categories" element={<RiteCategories/>} />
            <Route path="/restaurant-customers-form" element={<RestaurantCustomerRegisterForm/>} />
          </Routes>
        </Box>
      </Box>

      {/* Session Dialog */}
      <Dialog
        open={showDialog}
        PaperProps={{ sx: { borderRadius: 3, minWidth: 350 } }}
      >
        <DialogTitle sx={{ fontWeight: 600, color: SIDEBAR_BG }}>
          Session Expiring
        </DialogTitle>

        <DialogContent>
          <DialogContentText>
            Your session will expire in 5 minutes. Do you want to continue?
          </DialogContentText>

          {loading && (
            <CircularProgress size={24} sx={{ mt: 2, color: SIDEBAR_ACTIVE }} />
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={handleContinueSession}
            variant="contained"
            disabled={loading}
            sx={{
              borderRadius: 2,
              backgroundColor: SIDEBAR_ACTIVE,
              "&:hover": { backgroundColor: "#15635a" },
            }}
          >
            Continue
          </Button>

          <Button
            onClick={handleLogout}
            variant="outlined"
            disabled={loading}
            sx={{
              borderRadius: 2,
              color: "#ef4444",
              borderColor: "#ef4444",
            }}
          >
            Log Out
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
      >
        <Alert
          severity="error"
          onClose={() => setSnackbarOpen(false)}
          sx={{ borderRadius: 2 }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default RiteAdminRoutes;
